import React from "react";
import StateTag from "Components/state-tag";
import { formatDate, sort } from "Utils";
import OperationsColumn from "./operations-column";
import { Table, Tag } from "antd";
import Highlighter from "react-highlight-words";
import { RENTABLE_AREA_POSITIONS } from "Constants";

export default function RentableAreasTable({
  data,
  IsAuthorized,
  loading,
  filteredValue,
  onSetFilteredValue,
  onOperationExecuted,
  ...props
}) {
  const columns = [
    {
      title: "Kod",
      width: 80,
      dataIndex: "code",
      key: "code",
      ellipsis: true,
      sorter: (a, b) => {
        return a.code.substr(2) - b.code.substr(2);
      },
    },

    {
      title: "Birim",
      dataIndex: ["subUnit", "unit"],
      key: "code",
      width: 200,
      ellipsis: true,
      render: (text, record) => {
        return `${record.subUnit.unit.description}`;
      },
      sorter: (a, b) => {
        return sort(a.subUnit?.unit?.description, b.subUnit?.unit?.description);
      },
    },

    {
      title: "Alt Birim",
      dataIndex: ["subUnit", "code"],
      key: "code",
      width: 200,
      ellipsis: true,
      render: (text, record) => {
        return `${record.subUnit.description}`;
      },
      sorter: (a, b) => {
        return sort(a.subUnit?.description, b.subUnit?.description);
      },
    },

    {
      title: "Türü",
      dataIndex: ["rentableAreaType", "description"],
      key: "rentableAreaType",
      width: 150,
      ellipsis: true,
      render: (text, record) => {
        return `${record.rentableAreaType.description}`;
      },
      sorter: (a, b) => {
        return sort(
          a.rentableAreaType?.description,
          b.rentableAreaType?.description
        );
      },
    },

    {
      title: "Açıklama",
      dataIndex: "description",
      key: "description",
      width: 200,
      ellipsis: true,
      sorter: (a, b) => {
        return sort(a.description, b.description);
      },
      sorter: true,
    },
    {
      title: "Adres",
      dataIndex: "address",
      key: "address",
      width: 200,
      ellipsis: true,
    },

    {
      title: "Durum",
      dataIndex: "position",
      key: "position",
      width: 100,
      ellipsis: true,
      render: (text, record) => (
        <>
          <StateTag state={record.state} />
          <Tag color={record.position === "EMPTY" ? "green" : "blue"}>
            {RENTABLE_AREA_POSITIONS[record.position]}
          </Tag>
        </>
      ),
      sorter: (a, b) => {
        return sort(
          RENTABLE_AREA_POSITIONS[a.position],
          RENTABLE_AREA_POSITIONS[b.position]
        );
      },
    },

    {
      title: "Yaratma Tarihi",
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: true,
      width: 180,
      ellipsis: true,
      render: (text, record) => formatDate(record.createdAt),
      sorter: (a, b) => {
        return sort(a.createdAt, b.createdAt);
      },
    },
    {
      title: "İşlemler",
      width: 80,
      fixed: "right",
      dataIndex: "operation",
      render: (text, record) => (
        <OperationsColumn
          collapsed={true}
          record={record}
          onOperationExecuted={onOperationExecuted}
        />
      ),
    },
  ];

  return (
    <Table
      style={{ margin: "0 24px" }}
      rowKey={(row) => row.id}
      loading={loading}
      dataSource={data}
      columns={columns}
      locale={{
        filterConfirm: "Filtrele",
        filterReset: "Temizle",
        emptyText: IsAuthorized
          ? "Kayıt Bulunamadı"
          : "Bu işlem için yetkiniz yok. Sistem yöneticiniz ile iletişime geçebilirsiniz.",
      }}
      pagination={{
        total: data.length,
        pageSize: 20,
        showSizeChanger: false,
        showTotal: (total, range) => {
          return `Toplam ${total} sonuçtan ${range.join(
            "-"
          )} arası gösteriliyor.`;
        },
      }}
      size="small"
      bordered
      showSorterTooltip={false}
      scroll={{ x: 1000, scrollToFirstRowOnChange: true }}
    />
  );
}
